import Button from "@/Components/Button";
import Image from "next/image";
// import dynamic from "next/dynamic";

import { BannerBlock } from "../index";
import Link from "next/link";
// import BannerCard from "./BannerCard";
// const MobileCardSlider = dynamic(() => import("./MobileCardSlider"), {
//   ssr: false,
// });

interface BannerProps {
  data?: BannerBlock;
  isMobile?: boolean;
}

const Banner: React.FC<BannerProps> = ({ data }) => {
  const bannerTitle = data?.title;
  const bannerDescription = data?.description;
  const bannerSubTitle = data?.sub_title;
  const label = data?.Cta?.label;
  const href = data?.Cta?.href;
  const bannerAnimation = data?.banner_animation?.data?.attributes?.url || "";
  const bannerAnimationLink = data?.banner_animation_link || "";

  const baseUrl = `${process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL}`;

  // Helper function to check if file is a video
  const isVideoFile = (filename: string): boolean => {
    const videoExtensions = [".mp4", ".webm", ".ogg", ".mov", ".avi", ".mkv"];
    const extension = filename
      .toLowerCase()
      .substring(filename.lastIndexOf("."));
    return videoExtensions.includes(extension);
  };

  // Helper function to check if file is an image
  const isImageFile = (filename: string): boolean => {
    const imageExtensions = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".webp",
      ".svg",
      ".bmp",
    ];
    const extension = filename
      .toLowerCase()
      .substring(filename.lastIndexOf("."));
    return imageExtensions.includes(extension);
  };

  // const slugify = (text: string) =>
  //   text
  //     .toLowerCase()
  //     .trim()
  //     .replace(/[^\w\s-]/g, "") // remove special chars
  //     .replace(/\s+/g, "-"); // spaces → dash

  return (
    <>
      <section></section>
      <div className="bg-background-dark relative lg:pt-[96px] pt-[80px] min-h-[500px] sm:min-h-[642px]">
        <div className="container relative overflow-hidden">
          <div
            className="absolute top-0 right-[-50%] z-0 w-full h-[300px] sm:w-[60%] sm:h-[642px] object-cover max-h-full sm:absolute sm:top-0 sm:right-0"
            aria-hidden="true"
          >
            {bannerAnimationLink ? (
              // External CDN Video
              <video
                src={bannerAnimationLink}
                width={500}
                height={642}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                poster="/images/poster/services.webp"
                // @ts-expect-error - fetchPriority is valid but not in React types yet
                fetchPriority="high"
                className="w-full object-cover h-full max-h-full opacity-[7%]"
                style={{ aspectRatio: "500 / 642" }}
                aria-label="Banner background video (CDN)"
                onError={(e) => {
                  console.warn("CDN video failed to load");
                  e.currentTarget.style.display = "none";
                }}
              />
            ) : bannerAnimation && isVideoFile(bannerAnimation) ? (
              <video
                src={`${baseUrl}${bannerAnimation}`}
                width={500}
                height={642}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                poster="/images/poster/services.webp"
                // @ts-expect-error - fetchPriority is valid but not in React types yet
                fetchPriority="high"
                className="w-full object-cover h-full max-h-full opacity-[7%]"
                style={{ aspectRatio: "500 / 642" }}
                aria-label="Banner background video"
              />
            ) : bannerAnimation && isImageFile(bannerAnimation) ? (
              <Image
                src={`${baseUrl}${bannerAnimation}`}
                width={500}
                height={642}
                sizes="(max-width: 640px) 100vw, 60vw"
                alt="Banner background image"
                className="w-full object-cover h-full max-h-full opacity-[7%]"
                style={{ aspectRatio: "500 / 642" }}
                loading="eager"
                priority
              />
            ) : null}
            <div
              className="
                  bg-[radial-gradient(29.73%_50%_at_50%_50%,_rgba(0,_0,_0,_0)_77.4%,_#040405_100%)] 
                  w-full 
                  object-cover 
                  h-full 
                  max-h-full 
                  absolute 
                  top-0 right-0 z-0"
            ></div>
          </div>
          <div className="relative z-20">
            <div className="xl:pt-[121px] md:pt-[72px] pt-[56px] xl:pb-[153px] md:pb-[102px] pb-[130px] ">
              <h1 className="text-display font-extrabold text-primary-text-white uppercase mt-4 max-w-[1078px]">
                {bannerTitle || ""}
              </h1>
              <div className="flex justify-start items-stretch gap-6 mt-4">
                <div className="w-1.5 bg-[linear-gradient(179.61deg,_#8ABC00_3.58%,_#0086E6_97.78%)]"></div>
                <div>
                  <p className="text-secondary-text-white text-subtitle-2 font-regular max-w-[578px]">
                    {bannerDescription || bannerSubTitle || ""}
                  </p>
                  {href && label && (
                    <Link href={href}>
                      <Button className="mt-4" label={label} />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Image
          src="/images/ServicesPage/banner-bg-blue.svg"
          alt=""
          width={500}
          height={200}
          sizes="(max-width: 640px) 100vw, 60vw"
          className="w-full sm:w-[60%] object-cover h-[100%] max-h-full absolute top-0 left-0 z-0"
          style={{ aspectRatio: '500 / 200' }}
          loading="eager"
          priority
          aria-hidden="true"
        />
        <Image
          src="/images/ServicesPage/banner-bg-green.svg"
          alt=""
          width={500}
          height={200}
          sizes="(max-width: 640px) 100vw, 60vw"
          className="w-full sm:w-[60%] object-cover h-[100%] max-h-full absolute top-0 right-0 z-0"
          style={{ aspectRatio: '500 / 200' }}
          loading="eager"
          priority
          aria-hidden="true"
        /> */}
      </div>
      {/* <div className="container relative z-30 ">
        {/* Desktop */
      /*}

      {!isMobile && (
        <div className="grid-cols-4 gap-[30px] xl:mt-[-60px] mt-[-55px] md:grid ">
          {data?.bannerCard.map((card, index) => (
            <BannerCard
              key={card.id}
              title={card.title}
              theme={index % 2 === 0 ? "blue" : "green"} // blue, green, blue...
              onclick={() => {
                const target = document.getElementById(
                  card?.link?.href?.replace("#", "") || slugify(card.title),
                );

                if (target) {
                  const y =
                    target.getBoundingClientRect().top + window.scrollY - 100; // 100px offset
                  window.scrollTo({ top: y, behavior: "smooth" });
                }
              }}
            />
          ))}
        </div>
      )}

      {/* Mobile Slider */
      /*}
      {isMobile && <MobileCardSlider data={data} />}
    </div > */}
    </>
  );
};

export default Banner;
